export enum StatusActionTypes {
    API_RESPONSE_SUCCESS = "@@status/API_RESPONSE_SUCCESS",
    API_RESPONSE_ERROR = "@@status/API_RESPONSE_ERROR",
    GET_STATUS = "@@status/GET_STATUS",
    ADD_STATUS = "@@status/ADD_STATUS",
    UPDATE_STATUS = "@@status/UPDATE_STATUS",
    DELETE_STATUS = "@@status/DELETE_STATUS",
  }
  